import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class MachineCreateTask extends GenericRequest {

    _request; // MachineCreateRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.MACHINE_ADD);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/create/machine-create/MachineCreateTask.js